import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { PROMO } from "../../lib/promo";
import { PROMO_IDS } from "../../constants/testIds";

// Homepage promo band. Temporary. Renders nothing when PROMO.enabled is false.
export default function PromoBand() {
  if (!PROMO.enabled) return null;

  return (
    <section
      data-testid={PROMO_IDS.homeBand}
      className="bg-umber text-linen paper-grain py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-end">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-[1px] w-10 bg-linen/50" />
              <span className="font-meta text-linen/70">{PROMO.eyebrow}</span>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.08] tracking-tight">
              Opening offers, for a{" "}
              <span className="font-display-italic text-sage">
                limited time.
              </span>
            </h2>
          </Reveal>
          <Reveal delay={200}>
            <Link
              to={`${PROMO.path}?from=home-band`}
              data-testid={PROMO_IDS.homeBandCta}
              className="group inline-flex items-center gap-3 mt-8 text-[12px] tracking-[0.22em] uppercase text-linen py-3 min-h-[44px]"
            >
              View the offers
              <ArrowUpRight
                size={17}
                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </Link>
          </Reveal>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {PROMO.offers.map((o, i) => (
            <Reveal key={o.id} delay={150 + i * 100} className="h-full">
              <Link
                to={`${PROMO.path}?offer=${o.id}&from=home-band`}
                data-testid={PROMO_IDS.homeBandOffer(i)}
                className="group flex flex-col h-full border border-linen/20 p-7 md:p-8 transition-colors duration-300 hover:border-linen/50 hover:bg-linen/[0.04]"
              >
                <div className="font-meta text-[10px] text-linen/50">
                  {PROMO.eyebrow}
                </div>
                <div className="mt-4 grid grid-cols-[minmax(84px,32%)_1fr] gap-4 items-start">
                  <div className="font-display text-3xl md:text-4xl leading-none text-sage text-center pt-1">
                    {o.price}
                  </div>
                  <div className="border-l border-linen/25 pl-4">
                    <div className="font-display text-lg leading-snug text-linen">
                      {o.name}
                    </div>
                    <p className="mt-2 mb-6 text-sm leading-relaxed text-linen/70">
                      {o.description}
                    </p>
                  </div>
                </div>
                <div className="mt-auto pt-4 border-t border-linen/15 text-[11px] tracking-[0.14em] uppercase text-linen/50">
                  {o.provider}
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 mt-10">
        <p className="text-[11px] leading-relaxed text-linen/65 max-w-2xl">
          {PROMO.finePrint}
        </p>
      </div>
    </section>
  );
}
